import * as _ from 'lodash'
import * as React from 'react'
import Persistence from '../Components/Persistence'
import { Link, Navigate } from 'react-router-dom'

import { InputField } from '../Components/Form/InputField'

import SDKFactory from '../Components/SDKFactory'
import { T } from '@homeschooling/sdk'
import brandHero from '../Components/brand/hero.png'


Persistence.setValues()

interface Form {
    [key: string]: string
  }

interface Props { }

interface State {
    user: number,
    form: Form,
    updateForm: Form,
    studentForm: Form,
    errors: { [key: string]: string }
    progress: string,
    isValid: boolean
}

export class Signup extends React.Component<Props, State> {

    private sdk = SDKFactory.getUsersSDK()

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          user: 0,
          form: {
            email: '',
            password: '',
            confirm: ''
          },
          updateForm: {

          },
          studentForm: {

          },
          errors: {}, 
          progress: 'register',
          isValid: false
        }
      }

      public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          const { form } = this.state
          form[key] = e.target.value

          if(key === 'email') this.setState({ isValid: e.target.validity.valid})

          this.setState({
            form,
          })
        }     


      public isBot = () => {
        let userAgent = window.navigator.userAgent

         if (userAgent.startsWith('facebookexternalhit') ||
              userAgent === 'Facebot' ||
              userAgent.startsWith('Twitterbot') ||
              userAgent.includes('bot') || // General check for "bot" string
              userAgent.includes('crawler') || // General check for "crawler" string
              userAgent.includes('spider') // General check for "spider" string
            ) {
              return true 
        }

        return false
      }

      public isValidEmail (email: string) {

      }

    public createUser = async () => {

        try {

          let errors: any = {}

          let password = this.state.form.password

          if (password.length < 8) errors['password'] = 'Password must be atleast 8 characters'
          if (password.length > 20) errors['password'] = 'Password must be less than 20 characters'
          if (password !== this.state.form.confirm) errors['confirm'] = 'Password and confirmation does not match'

          if (this.isBot() || ! this.state.isValid) errors['email'] = 'Valid email required'

            if (Object.keys(errors).length !== 0) {
              this.setState({ errors: errors })
              return
            }

            const res = await this.sdk
              .signUpUser(
                this.state.form.email,
                this.state.form.password,
                'PARENT'
              )
      
              let user = res.data
              const hasError: boolean = _.get(user, 'error', false) as boolean
              console.log('this is a returned user', user, 'hasError', hasError)
              if(!hasError){
               user = user as T.User
                Persistence.setAuth(user)
                this.setState({user: Number(user.id)})
              } else {
                let error = user as T.ErrorMessage
                this.setState({errors: {email: error.error}})
              }
          } catch (reason) {
            let errors  = {email: 'There was a problem with your registration. Please contact support or try again'}
            this.setState({errors})
            console.log('failed to register user', this.state.form, reason)
          }  
    } 

    public updateUser = async () => {
        this.setState({progress: 'student'})
    }

    public addStudent = async () => {

    }

    public goToMain = () => {
        this.setState({progress: 'main'})
    }

    private SignUpForm = () => {

        const { form } = this.state
        
        return (
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl">
                          Create an account
                      </h1>
                      <form noValidate className="space-y-4 md:space-y-6 text-white" action="#">
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('email')}
                            disabled={false}
                            errors={this.state.errors?.email}
                            helperErrors={true}
                            label={'Email'}
                            labelColor='default'
                            id='email'
                            required={true}
                            type='email'
                            value={form.email}
                          >

                          </InputField>
                          </div>
                          
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('password')}
                            disabled={false}
                            errors={this.state.errors?.password}
                            helperErrors={true}
                            label={'Password'}
                            labelColor='default'
                            id='password'
                            required={true}
                            type='password'
                            value={form.password}
                          >

                          </InputField>
                          </div>
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('confirm')}
                            disabled={false}
                            errors={this.state.errors?.confirm}
                            helperErrors={true}
                            label={'Confirm Password'}
                            labelColor='default'
                            id='confirm'
                            required={true}
                            type='password'
                            value={form.confirm}
                          >

                          </InputField>
                          </div>
                          <div className="flex items-start">
                              <div className="flex items-center h-5">
                                <input id="terms" aria-describedby="terms" type="checkbox" className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300" />
                              </div>
                              <div className="ml-3 text-sm">
                                <label className="font-light text-gray-500">I accept the <Link className="font-medium text-primary-600 hover:underline" to="#">Terms and Conditions</Link></label>
                              </div>
                          </div>
                          <button type="button" onClick={this.createUser} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create an account</button>
                          <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                              Already have an account? <Link to="/login" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</Link>
                          </p>
                      </form>
                  </div>
        )
    }

    private updateForm = () => {

        return (
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                          Update Account
                      </h1>
                      <form className="space-y-4 md:space-y-6" action="#">
                      <div>
                          <button type="button" onClick={this.updateUser} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
                          <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                              Already have an account? <Link to="/login" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</Link>
                          </p>
                          </div>
                      </form>
                  </div>
        )
    }

    private studentForm = () => {

        return (
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                          Add a student
                      </h1>
                      <form className="space-y-4 md:space-y-6" action="#">
                      <div>
                          <button type="submit" onClick={this.goToMain} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
                          <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                              Already have an account? <Link to="/login" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</Link>
                          </p>
                          </div>
                      </form>
                  </div>
        )
    }

    public render () {

        const { progress } = this.state

        let section = this.SignUpForm()

        const user = Persistence.getUserId()

         if(user > 0) {
                    return(<Navigate to='/schedule' />)
                }
        

        switch (progress) {
            case 'register':
                section = this.SignUpForm()
                break
            case 'update':
                section = this.updateForm()
                break
            case 'student':
                section = this.studentForm()
                break
            case 'main':
                return (<Navigate to='/schedule' />)
        }

        return (
          
          <section className="bg-gray-300 border-y-2">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
              <div className='mb-8 flex flex-col items-center justify-cent'>
                <img src={brandHero} className='w-48 sm:w-96 object-cover' alt="Homeschool and Daily Activity Tracker"/>
              </div>
          
              <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
                  {
                    section
                  }
              </div>
          </div>
        </section>
        )
    }
}

export default Signup